var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6169 5.05762C13.5556 5.04886 13.4942 5.04886 13.4329 5.05762C12.0742 5.0138 10.9961 3.90059 10.9961 2.53319C10.9961 1.1395 12.1268 0 13.5293 0C14.923 0 16.0625 1.13073 16.0625 2.53319C16.0537 3.90059 14.9756 5.0138 13.6169 5.05762Z",
    fill: "#065F46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4749 11.132C15.4932 11.7894 14.1171 12.0349 12.8461 11.8683C13.1792 11.1496 13.3545 10.3519 13.3632 9.51044C13.3632 8.6339 13.1704 7.80119 12.8022 7.07366C14.0995 6.89835 15.4757 7.14378 16.4662 7.80119C17.8511 8.71279 17.8511 10.2117 16.4749 11.132Z",
    fill: "#065F46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89625 5.05762C3.95761 5.04886 4.01896 5.04886 4.08032 5.05762C5.43895 5.0138 6.5171 3.90059 6.5171 2.53319C6.5171 1.13073 5.38636 0 3.9839 0C2.59021 0 1.45947 1.13073 1.45947 2.53319C1.45947 3.90059 2.53761 5.0138 3.89625 5.05762Z",
    fill: "#065F46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99263 9.5106C3.99263 10.3608 4.1767 11.1673 4.50979 11.8948C3.27387 12.0263 1.98536 11.7633 1.0387 11.141C-0.346232 10.2206 -0.346232 8.72172 1.0387 7.80135C1.97659 7.17025 3.30016 6.91605 4.54485 7.0563C4.18547 7.79259 3.99263 8.6253 3.99263 9.5106Z",
    fill: "#065F46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87533 12.1576C8.80521 12.1488 8.72632 12.1488 8.64743 12.1576C7.0346 12.105 5.74609 10.7814 5.74609 9.15103C5.75486 7.48561 7.09596 6.13574 8.77015 6.13574C10.4356 6.13574 11.7854 7.48561 11.7854 9.15103C11.7767 10.7814 10.4969 12.105 8.87533 12.1576Z",
    fill: "#065F46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02637 13.9721C4.7028 14.8574 4.7028 16.3124 6.02637 17.189C7.53402 18.197 10.0059 18.197 11.5135 17.189C12.8371 16.3037 12.8371 14.8486 11.5135 13.9721C10.0146 12.9641 7.54278 12.9641 6.02637 13.9721Z",
    fill: "#065F46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.37033fc5f8fb8aa48c773df34a557f9b.svg";
export { ForwardRef as ReactComponent };